import { Box, Button, IconButton, styled } from '@mui/material';

export const ToolbarContainer = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '2px',
  padding: '6px 8px',
  borderBottom: '1px solid #EAECF0',
  backgroundColor: '#FAFAFA',
}));

export const Divider = styled(Box)(() => ({
  width: '1px',
  height: '20px',
  backgroundColor: '#D9D9D9',
  margin: '0 6px',
}));

interface ToolbarButtonProps {
  selected?: boolean;
}

export const ToolbarButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<ToolbarButtonProps>(({ theme, selected }) => ({
  width: '28px',
  height: '28px',
  borderRadius: '6px',
  color: '#475467',

  '& span': {
    fontSize: '18px',
  },

  '&:hover': {
    backgroundColor: selected
      ? theme.palette.secondary.dark
      : `${theme.palette.secondary.main}26`,
  },

  ...(selected && {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
  }),
}));

export const ColorPopoverContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px',
}));

export const ColorGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: '8px',
  alignItems: 'center',
}));

export const CustomColorCell = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

export const ConfirmCustomColorButton = styled(IconButton)(({ theme }) => ({
  width: '22px',
  height: '22px',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,

  '& span': {
    fontSize: '16px',
  },

  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
  },
}));

export const ColorPopoverFooter = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const ConfirmColorButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  width: 'fit-content',
  height: 'auto',
  minHeight: 'unset',
  whiteSpace: 'nowrap',
  fontSize: '13px',
  padding: '6px 16px',
}));

interface ColorSwatchProps {
  swatchColor: string;
  selected?: boolean;
}

export const ColorSwatch = styled('button', {
  shouldForwardProp: (prop) => prop !== 'swatchColor' && prop !== 'selected',
})<ColorSwatchProps>(({ swatchColor, selected }) => ({
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  backgroundColor: swatchColor,
  border: selected ? '2px solid #1A1A1A' : '1px solid #D9D9D9',
  cursor: 'pointer',
  padding: 0,
}));

export const CustomColorInput = styled('input')(() => ({
  width: '28px',
  height: '28px',
  padding: 0,
  border: '1px solid #D9D9D9',
  borderRadius: '50%',
  cursor: 'pointer',
  overflow: 'hidden',
}));

export const LinkPopoverContent = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  padding: '12px',
}));

export const ApplyLinkButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  width: 'fit-content',
  whiteSpace: 'nowrap',
  padding: '6px 16px',
}));
